import axios from 'axios';
import NetworkUtils from './network-utils';
import qs from 'qs';

const HttpClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

HttpClient.interceptors.request
  .use((request) => {
    request.metadata = {
      startTime: Date.now(),
      id: Math.round(Math.random()*999999).toString(16)
    };
    if (request.data && Object.keys(request.data).length > 0 && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      request.data = qs.stringify(request.data);
    }

    NetworkUtils.logRequestInfo(request);

    return request;
  }, error => Promise.reject(error));

HttpClient.interceptors.response
  .use((response) => {
    response.config.metadata.endTime = Date.now();
    response.duration = response.config.metadata.endTime - response.config.metadata.startTime;
    NetworkUtils.logResponseInfo(response);

    return response;
  }, error => {
    error.config.metadata.endTime = Date.now();
    error.duration = error.config.metadata.endTime - error.config.metadata.startTime;
    NetworkUtils.logResponseInfo(error);
    if (error.response) {
      return Promise.resolve(error.response);
    }
    Promise.reject(error)
  });

export default HttpClient;



// WEBPACK FOOTER //
// ./src/network/http-client.js